'use es6';

import { createSelector } from 'reselect';
export const getLifecycleStages = state => state.lifecycleStages;
export const getLifecycleStageLabelsByStageId = createSelector(getLifecycleStages, lifecycleStages => lifecycleStages.reduce((labelsByStageId, stage) => Object.assign({}, labelsByStageId, {
  [stage.stageId]: stage.label
}), {}));